// extracted by mini-css-extract-plugin
export var modalidadItem = "ModalidadItem-module--modalidad-item--CK0d7";